import type { MessagingCreateChatRoom201BasicInfoAllOf } from './messagingCreateChatRoom201BasicInfoAllOf';
import type { MessagingCreateChatRoom201BasicInfoAllOfTwo } from './messagingCreateChatRoom201BasicInfoAllOfTwo';

export type MessagingCreateChatRoom201BasicInfo = MessagingCreateChatRoom201BasicInfoAllOf & MessagingCreateChatRoom201BasicInfoAllOfTwo;
